

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  wrapper: function wrapper(props) {return {
      display: 'flex',
      position: 'relative',
      font: {
        family: ['Lato', 'sans-serif']
      },
      width: props.width ? props.width : '25rem'
    };},
  contributionBlock: function contributionBlock(_ref) {var additionalOptions = _ref.additionalOptions;return {
      width: (additionalOptions === null || additionalOptions === void 0 ? void 0 : additionalOptions.contributionType) && 'auto'
    };},
  wrapperColumn: {
    flex: {
      direction: 'column'
    }
  },
  wrapperRow_reverse: {
    justifyContent: 'flex-end',
    flex: {
      direction: 'row-reverse',
      wrap: 'wrap-reverse'
    }
  },
  descriptionWrapper: function descriptionWrapper(_ref2) {var inputType = _ref2.inputType;return {
      display: 'flex',
      justifyContent: 'space-between',
      // 'row_reverse' inputType is for nested input component
      alignItems: inputType === 'row_reverse' ? 'flex-start' : 'flex-end',

      marginTop: inputType === 'row_reverse' ? '1rem' : 0
    };},
  description: {
    cursor: 'default',
    display: 'block',
    alignItems: 'flex-end',
    textOverflow: 'clip',
    overflowWrap: 'break-word',
    margin: { top: 0, bottom: '0.4rem' },
    paddingLeft: '1rem',
    boxSizing: 'border-box',
    color: colors.neutral[600],
    '&:focus': {
      outline: 'none'
    }
  },
  label: {
    color: colors.neutral[900],
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500
    },
    marginBottom: '0.4rem',
    letterSpacing: '0.02rem'
  },
  input: function input(_ref3) {var inputType = _ref3.inputType;return {
      // now nested input width is static, if it must be dynamic
      // add additional class directly for input
      width: inputType === 'row_reverse' ? '10rem' : inputType === 'row_end' ? '50rem' : 'auto',
      borderRadius: '4px',
      boxSizing: 'border-box',
      color: colors.neutral[900],
      font: {
        size: '1.6rem',
        lineHeight: '2.4rem'
      },
      padding: '0.8rem',
      letterSpacing: '0.02rem',
      height: '4.4rem',

      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: colors.neutral[500]
      }
    };},
  searchInput: function searchInput(props) {return {
      paddingLeft: props.htmlType === 'search' && '3.6rem'
    };},
  contributionInput: function contributionInput(props) {var _props$additionalOpti, _props$additionalOpti2;return {
      paddingLeft: ((_props$additionalOpti = props.additionalOptions) === null || _props$additionalOpti === void 0 ? void 0 : _props$additionalOpti.contributionType) === 'dollar' && '2.8rem',
      paddingRight: ((_props$additionalOpti2 = props.additionalOptions) === null || _props$additionalOpti2 === void 0 ? void 0 : _props$additionalOpti2.contributionType) === 'percentage' && '2.8rem'
    };},
  inputValidationTrue: {
    border: ['0.1rem', 'solid', colors.neutral[200]],

    '&:focus': {
      border: ['0.1rem', 'solid', colors.blue[500]],
      caretColor: colors.blue[500]
    }
  },
  inputValidationFalse: function inputValidationFalse(props) {return {
      border:
      props.value === '' ?
      ['0.1rem', 'solid', colors.blue[300]] :
      ['0.1rem', 'solid', colors.red[500]]
    };},
  inputDisabled: {
    cursor: 'not-allowed',
    backgroundColor: colors.neutral[100],
    opacity: '0.7'
  },
  inlineIcon: {
    width: '1.7rem',
    height: '1.7rem',
    color: colors.neutral[600],
    position: 'absolute',
    bottom: '1.2rem',
    left: '1.2rem'
  },
  fieldWrapper: function fieldWrapper(props) {var _props$additionalOpti3;return {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      marginRight: props.inputType === 'row_reverse' ? '1rem' : 0,
      width: ((_props$additionalOpti3 = props.additionalOptions) === null || _props$additionalOpti3 === void 0 ? void 0 : _props$additionalOpti3.contributionType) && props.width
    };},
  contributionSign: function contributionSign(props) {var _props$additionalOpti4, _props$additionalOpti5;return {
      position: 'absolute',
      top: '0.9rem',
      left: ((_props$additionalOpti4 = props.additionalOptions) === null || _props$additionalOpti4 === void 0 ? void 0 : _props$additionalOpti4.contributionType) === 'dollar' && '1.2rem',
      right: ((_props$additionalOpti5 = props.additionalOptions) === null || _props$additionalOpti5 === void 0 ? void 0 : _props$additionalOpti5.contributionType) === 'percentage' && '1.2rem',
      fontSize: '1.8rem'
    };},
  contributionInterval: {
    marginLeft: '1.2rem',
    marginTop: '1rem',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    whiteSpace: 'nowrap'
  },
  contributionWrapper: {
    display: 'flex'
  },
  passwordButton: function passwordButton(props) {return {
      position: 'absolute',
      right: props.htmlType === 'password' && '1.2rem',
      color: colors.neutral[600],
      bottom: '1rem',
      top: '1rem',
      width: '2.4rem',
      height: '2.4rem'
    };},
  inputGuideline: {
    maxWidth: '100%'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map